/**
* Events Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Events Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'events-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.events-slider.splide' ).each( function( index, comp ) {
        const mainSplide = new Splide( comp, {
          type: 'slide',
          perPage: 2,
          perMove: 1,
          gap: '50px',
          pagination: false,
          drag: false,
          live: true,
          breakpoints: {
            1024: {
              perPage: 1,
            },
          },
        } );

        mainSplide.on( 'overflow', function( isOverflow ) {
          mainSplide.options = {
            arrows: isOverflow,
          };
        } );

        mainSplide.mount();
      } );

      $( '.events-slider' ).each( function( key, val ) {
        $( val ).find( '.feat-slider' ).slick( {
          arrows: false,
          dots: false,
          slidesToShow: 2,
          speed: 750,
          autoplay: false,
          variableWidth: false,
          infinite: false,
          cssEase: 'ease-in-out',
          // asNavFor: $( val ).find( '.nav-slider' ),
        } );

        // $( val ).find( '.nav-slider' ).slick( {
        //   arrows: false,
        //   dots: false,
        //   slidesToShow: 1,
        //   initialSlide: 1,
        //   autoplay: false,
        //   speed: 750,
        //   variableWidth: true,
        //   infinite: false,
        //   swipe: false,
        //   cssEase: 'ease-in-out',
        //   // asNavFor: $( val ).find( '.feat-slider' ),
        // } );


        $( val ).find( '.slider-prev' ).click( function() {
          $( this ).closest( '.events-slider' ).find( '.feat-slider' ).slick( 'slickPrev' );
        } );

        $( val ).find( '.slider-next' ).click( function() {
          $( this ).closest( '.events-slider' ).find( '.feat-slider' ).slick( 'slickNext' );

          if ( $( this ).closest( '.events-slider' ).find( '.slider-prev' ).attr( 'disabled' ) ) {
            $( this ).closest( '.events-slider' ).find( '.slider-prev' ).removeAttr( 'disabled' );
          }
        } );

        $( val ).find( '.feat-slider' ).on( 'afterChange', function( event, slick, currentSlide ) {
          const realCurrentSlide = currentSlide;
          const totalSlides = $( this ).closest( '.feat-slider' ).find( '.card-wrapper' ).length - 1;

          if ( currentSlide + 1 > 1 ) {
            $( this ).closest( '.events-slider' ).find( '.slider-prev' ).removeAttr( 'disabled' );
          } else {
            $( this ).closest( '.events-slider' ).find( '.slider-prev' ).attr( 'disabled', 'true' );
          }

          if ( realCurrentSlide === totalSlides ) {
            $( this ).closest( '.events-slider' ).find( '.slider-next' ).attr( 'disabled', 'true' );
          } else {
            $( this ).closest( '.events-slider' ).find( '.slider-next' ).removeAttr( 'disabled' );
          }
        } );


        $( val ).find( '.nav-slider' ).on( 'afterChange', function( event, slick, currentSlide ) {
          setTimeout( () => {
            // Set attributes for the current slide
            const $currentSlide = $( slick.$slides[currentSlide] );
            $currentSlide.attr( 'tabindex', '-1' ).attr( 'aria-hidden', 'true' );
          }, 0 ); // Ensures the execution happens after Slick updates
        } );

        // $( val ).find( '.nav-slider .slick-slide' ).click( function( e ) {
        //   e.preventDefault();
        //   const slideNum = $( this ).attr( 'data-slick-index' );
        //   $( val ).find( '.feat-slider' ).slick( 'slickGoTo', slideNum );
        // } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'events-slider', COMPONENT );
} )( app );
